import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo13/contaminacion.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad3Actividad6.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[7];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[8].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[8].path}`,
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[6].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[6].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>Lee el texto que aparece a continuación:</li>
      </ul>
      <div className="row align-items-center">
        <div className="col-md-6 col-12">
          <p className="fs-5">
            Cuando nos mudamos a este barrio no sabíamos que había una fábrica
            de pintura cerca. La fábrica bota bastante humo que nos hace toser.
            Los vecinos queremos que la cierren. Pero en la fábrica nos dicen
            que ellos llegaron primero a esta zona, y que nunca se debieron
            construir casas por acá. La verdad que el barrio es un poco
            complicado, no hay colegios cerca y tampoco posta médica.
          </p>
        </div>
        <div className="col-md-6 col-12">
          <img src={Imagen1} className="img-fluid" alt="Peruanos" />
        </div>
      </div>

      <ul className="mt-5">
        <li>
        Conversa con un compañero, compañera o familiar y responde estas preguntas:        </li>
      </ul>

      <p>¿Qué problema nos narra el texto?</p>
      <textarea className="form-control mb-4" rows={3} />

      <p>¿Cómo afecta el problema a Brayan y sus vecinos?</p>
      <textarea className="form-control mb-4" rows={3} />

      <p>¿Crees que en el barrio de Brayan hubo una adecuada planificación?</p>
      <textarea className="form-control mb-4" rows={3} />

      <p>¿Habrían cambiado las cosas con una planificación previa? ¿Por qué?</p>
      <textarea className="form-control mb-4" rows={3} />

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Lean el texto que aparece a continuación.
            Pida a un o una estudiante que lea el siguiente texto en voz alta:
          </li>
          <li>
            Lea la siguiente indicación: Ahora conversen entre todos en el
            salón. Tu profesor, profesora o familiar guiará el diálogo. Pida a un(a)
            estudiante que lea las siguientes preguntas en voz alta. Cópielas: - ¿Qué problema nos narra el texto? - ¿Cómo afecta el
            problema a Brayan y sus vecinos? - ¿Crees que en el barrio de Brayan
            hubo una adecuada planificación? - ¿Habrían cambiado las cosas con
            una planificación previa? ¿Por qué?
          </li>
          <li>
            Recoja las respuestas. Luego, busque un consenso
            entre todos:
            <ul>
              <li>
                <i>
                  ¿Cómo afecta el problema a Brayan y sus vecinos? ? (Posible
                  respuesta: Existe una fábrica que contamina y perjudica la
                  salud de los vecinos. Asimismo, no existen escuelas y postas
                  que queden cerca).
                </i>
              </li>
              <li>
                <i>
                  ¿Crees que en el barrio de Brayan hubo una adecuada
                  planificación? ? (Posible respuesta: No. Por ello, se presenta
                  el problema de personas que viven en una zona donde no se
                  debería construir viviendas).
                </i>
              </li>
              <li>
                <i>
                  “¿Habrían cambiado las cosas con una planificación previa?
                  ¿Por qué? (Posible respuesta: Probablemente las viviendas
                  estarían en una zona residencial, es decir, una zona donde hay
                  casas, colegios y postas. La fábrica estaría ubicada junto con
                  otras en una zona industrial).”
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
